'use client'

interface TimeoutErrorDisplayProps {
  isTimedOut: boolean
  onRetry: () => void
  /** When true, disables the retry button (e.g., when a transaction is still pending) */
  isRetryDisabled?: boolean
}

/**
 * Reusable timeout error display component for transaction dialogs.
 * Shows a yellow warning when an operation takes longer than expected,
 * with helpful explanations and a retry button.
 */
export function TimeoutErrorDisplay({ isTimedOut, onRetry, isRetryDisabled }: TimeoutErrorDisplayProps) {
  if (!isTimedOut) return null

  return (
    <div className="mt-4 rounded-lg border border-yellow-500/20 bg-yellow-500/10 p-3 text-sm text-yellow-400">
      <p className="font-medium">Operation taking longer than expected</p>
      <p className="mt-1 text-xs opacity-90">The transaction is taking longer than usual. This could be due to:</p>
      <ul className="mt-1 list-inside list-disc text-xs opacity-75">
        <li>Network congestion</li>
        <li>RPC node slowness</li>
        <li>Wallet confirmation pending</li>
      </ul>
      <button
        type="button"
        onClick={onRetry}
        disabled={isRetryDisabled}
        className={`mt-3 text-xs underline ${
          isRetryDisabled ? 'cursor-not-allowed text-yellow-400/50' : 'text-yellow-400 hover:text-yellow-300'
        }`}
      >
        {isRetryDisabled ? 'Transaction pending...' : 'Click to retry'}
      </button>
    </div>
  )
}
